(() => {
  if (customElements.get('ahc-chassis-selector')) return;
  const parameter = 'filter.p.m.custom.platform_chassis';
  const valuesFrom = (url) => url.searchParams.getAll(parameter).flatMap(value => value.split(',')).filter(Boolean);
  const normalise = (url, selector) => {
    if (!selector) return url;
    const codes = [...new Set(valuesFrom(url).filter(value => value !== 'ALL' && value !== 'Exx'))];
    url.searchParams.delete(parameter);
    if (codes.length) {
      if (selector.dataset.hasAll === 'true') codes.push('ALL');
      if (selector.dataset.hasExx === 'true' && codes.some(value => value.startsWith('E'))) codes.push('Exx');
      codes.forEach(code => url.searchParams.append(parameter, code));
    }
    return url;
  };
  window.ahcNormaliseChassisUrl = (value) => normalise(new URL(value, window.location.origin), document.querySelector('ahc-chassis-selector')).toString();
  class AhcChassisSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      document.addEventListener('collection:reloaded', this.onReload);
      window.addEventListener('popstate', this.onReload);
      this.refresh();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('collection:reloaded', this.onReload);
      window.removeEventListener('popstate', this.onReload);
    }
    onClick = (event) => {
      const link = event.target.closest('a[data-chassis-code]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.delete(parameter);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      if (link.dataset.chassisCode !== 'all') url.searchParams.set(parameter, link.dataset.chassisCode);
      window.location.assign(normalise(url, this).toString());
    };
    onReload = () => this.refresh();
    refresh() {
      const current = new URL(window.location.href);
      const codes = valuesFrom(current).filter(value => value !== 'ALL' && value !== 'Exx');
      this.querySelectorAll('a[data-chassis-code]').forEach(link => {
        const code = link.dataset.chassisCode;
        const selected = code === 'all' ? !codes.length : codes.includes(code);
        if (selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        const url = new URL(current);
        url.searchParams.delete(parameter);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        if (code !== 'all') url.searchParams.set(parameter, code);
        link.href = normalise(url, this).toString();
      });
    }
  }
  customElements.define('ahc-chassis-selector', AhcChassisSelector);
})();
